<template>
    <div>
        <apexchart height="550" type="bar" :options="chartOptions" :series="chartSeries" />
    </div>
</template>

<script>
import apexchart from 'vue-apexcharts'

export default {
    components: {
        apexchart
    },
    computed: {
        chartOptions() {
            return {
                yaxis: {
                    title: {
                        text: 'Semana de alojamento'
                    },
                    decimalsInFloat: 0
                },
                xaxis: {
                    type: 'categories',
                    categories: this.chartLabels,
                    title: {
                        text: 'Percentual'
                    },
                    labels: {
                        style: {
                            colors: '#000000de'
                        }
                    }
                },
                dataLabels: {
                    enabled: false
                },
                responsive: [{
                    options: {
                        legend: {
                            position: 'right'
                        }
                    }
                }],
                markers: {
                  size: 4
                },
                stroke: {
                    width: 1
                },
                plotOptions: {
                    bar: {
                        borderRadius: 4,
                        horizontal: true,
                    }
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val + '%'
                        }
                    }
                },
                legend: {
                    position: 'top',
                },
                fill: {
                    opacity: 1
                },
            };
        },
        chartSeries() {
            return this.values
        },
        chartLabels() {
            return this.categories
        }
    },
    props: {
        values: Array,
        categories: Array,
    }
}
</script>


